/**
 * Sends the funnel steps to Microsoft Clarity from the page itself.
 *
 * Clarity runs twice on this store. The app embed loads the real tag in the
 * page — recordings, heatmaps and the _clck/_clsk cookies all work, and its
 * uploads answer 200. The Clarity app *also* registers a Shopify web pixel,
 * and that copy runs inside Shopify's strict sandbox, where its upload URL
 * resolves to a relative path. Every page load it throws
 *
 *   TypeError: Failed to construct 'URL': Invalid URL
 *     at XMLHttpRequest.open (cdn/wpm/…js)
 *     at web-pixel-4085580105
 *
 * and its POST to /api/collect is aborted. Session recordings survive that,
 * because they come from the tag in the page; the e-commerce events do not,
 * which is why Clarity's funnels disagree with Shopify's own numbers.
 *
 * That pixel's code belongs to the app and cannot be patched from the theme.
 * What we can do is send the same steps from the page, where the tag works.
 * The names below are our own, so if the app ever ships a fixed pixel the two
 * sets sit side by side instead of double-counting one funnel.
 *
 * Sent: page_type and market on every page, pdp_view on a product page,
 * add_to_cart when a cart write succeeds, begin_checkout on the way out.
 */
(function () {
  /** Clarity queues calls made before the tag finishes loading, so this is safe. */
  function track() {
    if (typeof window.clarity !== 'function') return;
    try {
      window.clarity.apply(null, arguments);
    } catch (error) {
      /* Analytics must never break a page. */
    }
  }

  function template() {
    const main = document.querySelector('main[data-template]');
    return (main && main.dataset.template) || '';
  }

  // -- Context, so the Norway and Sweden segments can be told apart ----------
  const shopify = window.Shopify || {};
  const pageType = template();

  track('set', 'page_type', pageType || 'unknown');
  if (shopify.country) track('set', 'market_country', String(shopify.country));
  if (shopify.currency && shopify.currency.active) {
    track('set', 'market_currency', String(shopify.currency.active));
  }
  if (pageType.indexOf('product') === 0) track('event', 'pdp_view');

  // -- Cart writes ----------------------------------------------------------
  // Wrapping fetch rather than listening for the theme's own events keeps this
  // working across theme updates, and catches the cart app's requests too.
  const CART_WRITE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  const nativeFetch = window.fetch;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      let url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (error) {
        url = '';
      }

      const result = nativeFetch.apply(this, arguments);
      if (!CART_WRITE.test(url)) return result;

      const isAdd = url.indexOf('/cart/add') !== -1;

      return result.then(function (response) {
        // Only a successful write is a funnel step. A rejected add — sold out,
        // or no size chosen yet — must not look like one.
        if (response && response.ok) {
          track('event', isAdd ? 'add_to_cart' : 'cart_updated');
        } else if (isAdd) {
          track('event', 'add_to_cart_failed');
        }
        return response;
      });
    };
  }

  // -- Leaving for checkout -------------------------------------------------
  // Capture phase: the cart form submits and navigates away, so a listener on
  // the button itself would race the unload.
  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest('[name="checkout"], a[href*="/checkout"]')) return;
      track('event', 'begin_checkout');
    },
    { capture: true }
  );
})();
